<template>
  <div :class="['tip_wrap', $style.text_wrap]">
    <tip-icon iconName="open" />
    <div :class="$style.right_wrap">
      <p :class="$style.lock_list">
        已锁定服务器：<span v-for="(item, index) in overLockServe" :key="index"
          >{{ item.server_name
          }}<span v-if="index + 1 != overLockServe.length">、</span></span
        >
      </p>
    </div>
  </div>
</template>
<script>
import tipIcon from "../../../components/TipIcon";
export default {
  name: "bindServer",
  props: {
    overLockServe: Array
  },
  components: {
    tipIcon
  }
};
</script>
<style lang="less" module>
.text_wrap {
  margin: 1rem 0 0.7rem 0;
  .right_wrap {
    width: 4.8rem;
  }
}
</style>
